import { PDFDocument } from 'pdf-lib';
import axios from 'axios';

export async function mergePdfs(transactionIds: number[]): Promise<string> {
  const mergedPdf = await PDFDocument.create();

  for (const id of transactionIds) {
    const response = await axios.get(
      `/v1/worker/receive-transactions/${id}/pdf`,
      { responseType: 'arraybuffer' }
    );
    const pdfDoc = await PDFDocument.load(response.data);
    const pages = await mergedPdf.copyPages(pdfDoc, pdfDoc.getPageIndices());
    pages.forEach((page) => mergedPdf.addPage(page));
  }

  const mergedPdfBytes = await mergedPdf.save();
  const blob = new Blob([mergedPdfBytes], { type: 'application/pdf' });
  return URL.createObjectURL(blob);
}
